import { withStyles } from '@material-ui/core/styles';
import { SortableHandle } from 'react-sortable-hoc';
import DragHandleIcon from '@material-ui/icons/DragHandle';

const styles = ({ palette }) => ({
  root: {
    cursor: 'row-resize',
    color: palette.cncUI.primary.gray['+3'],
  },
});

const DragHandle = ({ classes }) => <DragHandleIcon className={classes.root} />;

export default SortableHandle(withStyles(styles)(DragHandle));
